import React from 'react';
import {
  OnboardingWelcomeModal,
  SetupBrokerageWizardModal,
  OnboardingPreLaunchModal,
  UserSuggestedUpdateModal,
  FeedbackModal,
  AppointmentActionModal,
  ContextualChatModal,
  AddListingToTourModal,
  DIALOG_KEYS,
} from 'modals';
import { useDialogStore } from 'hooks/dialogStore/useDialogStore';

export default () => {
  const { isUsingNewArchitecture } = useDialogStore();

  const feedbackUsingNewArch = isUsingNewArchitecture(
    DIALOG_KEYS.FeedbackModal,
  );

  return (
    <>
      <AddListingToTourModal />
      <OnboardingWelcomeModal />
      <SetupBrokerageWizardModal />
      <OnboardingPreLaunchModal />
      <UserSuggestedUpdateModal />
      {feedbackUsingNewArch ? null : <FeedbackModal />}
      <AppointmentActionModal />
      <ContextualChatModal />
    </>
  );
};
